import { PropsWithChildren } from 'react';
import Header from '@app/shared/layout/header/Header';
import styles from './main-layout.module.scss';
// import { useAppSelector } from '@core/hooks/redux-hooks';
import MaintenanceBanner from '@app/modules/projects/maintenance/MaintenanceBanner';

const PARENT_CLASSNAME = 'main-layout';

export const MainLayout = ({ children }: PropsWithChildren<Record<never, never>>): JSX.Element => {
  return (
    <div className={styles[`${PARENT_CLASSNAME}`]}>
      <div className={styles[`${PARENT_CLASSNAME}__header-wrapper`]}>
        <MaintenanceBanner />
        <Header />
      </div>
      <div className={styles[`${PARENT_CLASSNAME}__content-wrapper`]}>{children}</div>
    </div>
  );
};
